import { Action, createReducer, on } from '@ngrx/store';
import {User} from '../../models/user.model';
import {login, logout}  from "../../store/user/user.action";
 
const initialState: User = {
    userId: 0,
    userName: 'Malachi',
    emailAddress: '',
    firstName: '',
    lastName: '',
    navCustomerNo: '',
    isLoggedIn: false
}
 
export const userReducer = createReducer(
    initialState,
    on(login, (state, {user}) => {
        return user;
    }),
     on(logout, (state) => initialState)
  );